import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";
const MentorMenteeReport = Loadable(
  lazy(() =>
    import(
      "views/application/users/social-profile/mentorship/mentorMenteeReport/index"
    )
  )
);
const MenteeList = Loadable(
  lazy(() =>
    import(
      "views/application/users/social-profile/mentorship/mentorMenteeReport/MenteeList"
    )
  )
);

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const MentorMenteeRoutes = {
  path: "/",
  element: (
    <AuthGuard roles={roles}>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/mentor-mentee/report",
      element: <MentorMenteeReport />,
    },
    {
      path: "/mentee-list/:id",
      element: <MenteeList />,
    },
  ],
};

export default MentorMenteeRoutes;
